import React, { useEffect, useState } from 'react';
import api from '../api';
import AgreementEvents from './AgreementEvents';

const statuses = { accepted: 'Принят', outdated: 'Принята прежняя версия', not_accepted: 'Не принят', revoked: 'Согласие отозвано' };

export default function AccountAgreements({ accountId }) {
    const [documents, setDocuments] = useState([]);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        let active = true;
        setLoading(true); setError('');
        api.get(`/api/admin/agreements/accounts/${accountId}`)
            .then(({ data }) => { if (active) setDocuments(data); })
            .catch(() => { if (active) setError('Не удалось загрузить соглашения'); })
            .finally(() => { if (active) setLoading(false); });
        return () => { active = false; };
    }, [accountId]);
    return <section className="mt-5 pt-5 border-t border-gray-200 text-left">
        <h4 className="font-semibold text-gray-900 mb-3">Принятые документы</h4>
        {loading && <p className="text-sm text-gray-500">Загрузка…</p>}
        {error && <p role="alert" className="text-sm text-red-600">{error}</p>}
        {!loading && !error && !documents.length && <p className="text-sm text-gray-500">Реестр пока пуст.</p>}
        <div className="space-y-3">
            {documents.map(document => <div key={document.id} className="rounded-lg border border-gray-200 p-3 text-sm">
                <p className="font-medium text-gray-900">{document.title}</p>
                <p className={document.status === 'accepted' ? 'text-emerald-600' : 'text-gray-500'}>{statuses[document.status]}</p>
                <p className="text-xs text-gray-500 mt-1">Актуальная: v{document.current.version}; принятая: {document.acceptedVersion ? `v${document.acceptedVersion}` : '—'}</p>
                {document.acceptedAt && <p className="text-xs text-gray-500">{document.acceptanceType === 'Document_Autoaccept' ? 'Автоакцепт' : 'Акцепт'} · {document.acceptedAt} (UTC)</p>}
                {document.acceptedDocument?.doc_hash && <a className="block mt-1 text-blue-600 text-xs" href={`/api/admin/agreements/${document.id}/versions/${document.acceptedVersion}/pdf`} target="_blank" rel="noopener noreferrer">PDF принятой версии</a>}
                {document.acceptedVersion && !document.acceptedDocument?.doc_hash && <p className="text-xs text-gray-500 mt-1">Для старой версии PDF и хэш не были сохранены.</p>}
            </div>)}
        </div>
        <details className="mt-4"><summary className="cursor-pointer text-sm text-blue-600">История акцептов и уведомлений</summary><AgreementEvents accountId={accountId} /></details>
    </section>;
}
